import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { RiskFreeBetRiskComponent } from './risk-free-bet-risk.component';


@NgModule({
  declarations: [
    RiskFreeBetRiskComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
  ]
})
export class RiskFreeBetRiskModule { }